export default [
    {
        path: '/places',
        name: 'places',
        component: () => import ('./pages/Index'),
        meta: {
            title: 'Prédios',
            icon: 'mdi-warehouse',
            breadcrumbs: [
                { text: 'Lista de prédios', disabled: true }
            ]
        }
    }
]